import { jsx as _jsx, jsxs as _jsxs } from "tsx-dom/jsx-runtime";
export function UnsupportedVideo() {
    return (_jsx("div", { id: "video-modal", class: "modal hidden", children: _jsxs("div", { class: "modal-area", children: [_jsx("span", { class: "close-modal" }), _jsx("div", { id: "video-holder" })] }) }));
}
